import { useSettings, useStyles } from '@wix/tpa-settings/react';
import { sectionSettingsCssProperties } from '../Settings/useSettingsSections';
import settingsParams, {
  uninitializedVisibilitySettingsTrueValue,
} from '../settingsParams';
import stylesParams from '../stylesParams';
import { ISection, SectionTypes } from '../types';
import { useWidgetSections } from '../Widget/useWidgetSections';
import { VisibilityKey } from './types';
import { useVisibilityExperiment } from './useVisibilityExperiment';

export function useVisibilityCheck() {
  const settings = useSettings();
  const { isVisibilityStyleParamsEnabled } = useVisibilityExperiment();
  const styles = useStyles();

  return {
    shouldBeVisible(key: VisibilityKey) {
      const settingsValue = settings.get(settingsParams[key]);
      if (isVisibilityStyleParamsEnabled) {
        return typeof settingsValue === 'boolean'
          ? settingsValue
          : styles
              .getStylesForAllBreakpoints()
              .some(({ booleans }) => booleans[key]);
      } else {
        return typeof settingsValue === 'boolean'
          ? settingsValue
          : settingsValue === uninitializedVisibilitySettingsTrueValue;
      }
    },
  };
}
